<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" @keyup.enter.native="submitForm" ref="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="累计运行" prop="totalRunningDuration">
              <a-input placeholder="请输入累计运行" v-model="model.totalRunningDuration"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction } from '@/api/manage'
  // import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'BaseInfoForm',
    components: {
    },

    props: {

      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        devProcessList: [],

        model: {
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        validatorRules: {
          // posName: [{ required: true, message: '请输入取样点名称!' }],
          // posCode: [{ required: true, message: '请输入取样点代号!' }, { validator: this.validateCode }]

        },
        url: {
          add: '/exam/techExamSamplepos/add',
          edit: '/device/devList/edit',
          queryById: '/exam/techExamSamplepos/queryById'
        }
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      }
    },
    created () {
      // 备份model原始值
      //    this.modelDefault = JSON.parse(JSON.stringify(this.deviceData))
    },
    methods: {
      validateCode (rule, value, callback) {
        if (!value) {
          callback()
        } else {
          if (
            !new RegExp(/^[0-9a-zA-Z_]{1,}$/).test(value)
          ) {
            callback('请输入正确格式的代号!')
          } else {
            callback()
          }
        }
      },
      add () {
        this.edit(this.modelDefault)
      },
      edit (record) {
        this.model = Object.assign({}, record)
        this.visible = true
      },
      submitForm () {
        const that = this
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true
            let httpurl = ''
            let method = ''
            if (!this.model.id) {
              httpurl += this.url.add
              method = 'post'
            } else {
              httpurl += this.url.edit
              method = 'put'
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            }).finally(() => {
              that.confirmLoading = false
            })
          }
        })
      }
    }
  }
</script>
